/**
 * ## Notes Controller
 *
 * @module src/controllers/notes
 */

"use strict";

const notification = require("../../components/notification");
const block = require("../../components/block");
const modal = require("../../components/modal");
const l = require("../../common").localization;

let note_id = "new";
let editMode = false;

/** Init
 */
const init = (kd) => {
  const refreshNotes = () => {
    const opt = {
      kd,
      targetDiv: "content_wide_notelist",
      static: true,
    };

    const data = {
      type: "note",
      domain: "activity",
      h1: "All Parties",
      h2: "...",
      expand: true,
      single: false,
      group: "all",
      refresh: 30,
      height: {},
      status: {
        min: 1,
        max: 2,
      },
      size: {
        min: 1,
        max: 500,
      },
      waited: {
        min: 0,
        max: 2000,
      },
    };

    block.create(opt, data, (err, value) => {
      editMode = false;
      $("#content_wide_col6").css("display", "block");
      if (value.value === "new") {
        note_id = "new";
        let body = '<div class="form_element_2">';
        body += `<div class="form_label_1">${l.translate("Subject:")}</div>`;
        body += '    <div class="form_field_1 form_100p">';
        body += '        <input id="note_subjectfield" type="text">';
        body += "    </div>";
        body += "</div>";
        body += '<div class="form_element_2">';
        body += `<div class="form_label_1">${l.translate("Note:")}</div>`;
        body += '    <div class="form_field_1 form_100p">';
        body +=
          '        <textarea id="note_bodyfield" class="form_450h"></textarea>';
        body += "    </div>";
        body += "</div>";
        body += '<div class="clear"></div>';
        $("#content_wide_notesubject").html("");
        $("#content_wide_notebody").html(body);
        $("#note_save").html(l.translate("Save"));
        $("#note_delete").css("display", "none");
      } else {
        note_id = value.value;
        const note = Object.assign({}, kd.doc("note", note_id)[0]);
        note.body += '<div class="clear"></div>';
        $("#content_wide_notesubject").html(note.subject);
        $("#content_wide_notebody").html(note.body.replace(/\n/g, "<br />"));
        $("#note_save").html(l.translate("Edit"));
        $("#note_delete").css("display", "inline-block");
      }
    });

    $("#note_save").off();
    $("#note_save").fastClick((e) => {
      if (
        $("#note_subjectfield").val() === "" ||
        $("#note_bodyfield").val() === ""
      ) {
        const opt2 = {
          position: "top",
          width: "90%",
          seconds: 3,
          h1: l.translate(
            "Please enter something for both the subject and note fields."
          ),
          body: "",
          buttons: [
            {
              description: l.translate("Close"),
              value: "close",
            },
          ],
        };
        notification.create(opt2, {}, (err, value) => {
          notification.destroy();
        });
      } else {
        let proposed = {
          domain: "note",
          _id: note_id,
          subject: stripScripts($("#note_subjectfield").val()),
          body: stripScripts($("#note_bodyfield").val()),
          active: 1,
        };
        if (proposed._id === "new") {
          delete proposed._id;
          kd.update(proposed)
            .then((result) => {
              note_id = result._id;
              let body = result.body;
              body += '<div class="clear"></div>';
              $("#content_wide_notesubject").html(result.subject);
              $("#content_wide_notebody").html(body);
              $("#note_save").html(l.translate("Edit"));
              $("#note_delete").css("display", "inline-block");
            })
            .catch((err) => {
              console.log("err", err);
            });
        } else {
          if (!editMode) {
            editMode = true;
            let body = '<div class="form_element_2">';
            body += `<div class="form_label_1">${l.translate(
              "Subject:"
            )}</div>`;
            body += '    <div class="form_field_1 form_100p">';
            body += '        <input id="note_subjectfield" type="text">';
            body += "    </div>";
            body += "</div>";
            body += '<div class="form_element_2">';
            body += `<div class="form_label_1">${l.translate("Note:")}</div>`;
            body += '    <div class="form_field_1 form_100p">';
            body += '        <textarea id="note_bodyfield" class="form_450h">';
            body += "</textarea>";
            body += "    </div>";
            body += "</div>";
            body += '<div class="clear"></div>';
            $("#content_wide_notesubject").html("");
            $("#content_wide_notebody").html(body);
            $("#note_subjectfield").val(kd.doc("note", note_id)[0].subject);
            $("#note_bodyfield").val(kd.doc("note", note_id)[0].body);
            $("#note_save").html(l.translate("Save"));
          } else {
            editMode = false;
            proposed = {
              domain: "note",
              _id: note_id,
              subject: stripScripts($("#note_subjectfield").val()),
              body: stripScripts($("#note_bodyfield").val()),
              active: 1,
            };
            kd.update(proposed)
              .then((result) => {
                const note = Object.assign({}, kd.doc("note", note_id)[0]);
                note.body += '<div class="clear"></div>';
                $("#content_wide_notesubject").html(note.subject);
                $("#content_wide_notebody").html(
                  note.body.replace(/\n/g, "<br />")
                );
                $("#note_save").html(l.translate("Edit"));
                $("#note_delete").css("display", "inline-block");
              })
              .catch((err) => {
                console.log("err", err);
              });
          }
        }
      }
    });

    $("#note_delete").off();
    $("#note_delete").fastClick((e) => {
      const opt2 = {
        width: "90%",
        type: "dialog",
        h1: l.translate("Delete Note"),
        body: l.translate("Are you sure you want to delete this note?"),
        buttons: [
          {
            description: l.translate("Cancel"),
            value: "cancel",
          },
          {
            description: l.translate("Delete it"),
            value: "delete",
          },
        ],
      };

      const data2 = {
        kd,
      };
      modal.create(opt2, data2, (err, value) => {
        modal.destroy();
        if (value.button === "delete") {
          $("#content_wide_col6").css("display", "none");
          const proposed = {
            domain: "note",
            _id: note_id,
            active: 0,
          };
          kd.update(proposed)
            .then((result) => {})
            .catch((err2) => {
              console.log("err2", err2);
            });
        }
      });
    });
  };

  refreshNotes();

  kd.on("note.update", () => {
    refreshNotes();
  });
};

const stripScripts = (s) => {
  const div = document.createElement("div");
  div.innerHTML = s;
  const scripts = div.getElementsByTagName("script");
  let i = scripts.length;
  while (i--) {
    scripts[i].parentNode.removeChild(scripts[i]);
  }
  return div.innerHTML;
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/notes/index.js
 **/